"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabButton = void 0;
var React = require("react");
var I18nLabel_1 = require("../I18nLabel");
var Actions_1 = require("../model/Actions");
var Rect_1 = require("../Rect");
var ICloseType_1 = require("../model/ICloseType");
var Types_1 = require("../Types");
/** @hidden @internal */
var TabButton = function (props) {
    var layout = props.layout, node = props.node, show = props.show, selected = props.selected, iconFactory = props.iconFactory, titleFactory = props.titleFactory, icons = props.icons;
    var selfRef = React.useRef(null);
    var contentRef = React.useRef(null);
    var contentWidth = React.useRef(0);
    var onMouseDown = function (event) {
        if (!layout.getEditingTab()) {
            var message = layout.i18nName(I18nLabel_1.I18nLabel.Move_Tab, node.getName());
            layout.dragStart(event, message, node, node.isEnableDrag(), onClick, onDoubleClick);
        }
    };
    var onClick = function () {
        layout.doAction(Actions_1.default.selectTab(node.getId()));
    };
    var onDoubleClick = function (event) {
        if (node.isEnableRename()) {
            layout.setEditingTab(node);
            layout.getCurrentDocument().body.addEventListener("mousedown", onEndEdit);
            layout.getCurrentDocument().body.addEventListener("touchstart", onEndEdit);
        }
        // else {
        //     const parentNode = node.getParent() as TabSetNode;
        //     if (parentNode.canMaximize()) {
        //         layout.maximize(parentNode);
        //     }
        // }
    };
    var onEndEdit = function (event) {
        if (event.target !== contentRef.current) {
            layout.getCurrentDocument().body.removeEventListener("mousedown", onEndEdit);
            layout.getCurrentDocument().body.removeEventListener("touchstart", onEndEdit);
            layout.setEditingTab(undefined);
        }
    };
    var isClosable = function () {
        var closeType = node.getCloseType();
        if (selected || closeType === ICloseType_1.ICloseType.Always) {
            return true;
        }
        if (closeType === ICloseType_1.ICloseType.Visible) {
            // not selected but x should be visible due to hover
            if (window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
                return true;
            }
        }
        return false;
    };
    var onClose = function (event) {
        if (isClosable()) {
            layout.doAction(Actions_1.default.deleteTab(node.getId()));
        }
        else {
            onClick();
        }
    };
    var onCloseMouseDown = function (event) {
        event.stopPropagation();
    };
    React.useLayoutEffect(function () {
        updateRect();
        if (layout.getEditingTab() === node) {
            contentRef.current.select();
        }
    });
    var updateRect = function () {
        // record position of tab in node
        var layoutRect = layout.getDomRect();
        var r = selfRef.current.getBoundingClientRect();
        node._setTabRect(new Rect_1.default(r.left - layoutRect.left, r.top - layoutRect.top, r.width, r.height));
        contentWidth.current = contentRef.current.getBoundingClientRect().width;
    };
    var onTextBoxMouseDown = function (event) {
        // console.log("onTextBoxMouseDown");
        event.stopPropagation();
    };
    var onTextBoxKeyPress = function (event) {
        // console.log(event, event.keyCode);
        if (event.keyCode === 27) {
            // esc
            layout.setEditingTab(undefined);
        }
        else if (event.keyCode === 13) {
            // enter
            layout.setEditingTab(undefined);
            layout.doAction(Actions_1.default.renameTab(node.getId(), event.target.value));
        }
    };
    var cm = layout.getClassName;
    var parentNode = node.getParent();
    var baseClassName = Types_1.CLASSES.FLEXLAYOUT__TAB_BUTTON;
    var classNames = cm(baseClassName);
    classNames += " " + cm(baseClassName + "_" + parentNode.getTabLocation());
    if (selected) {
        classNames += " " + cm(baseClassName + "--selected");
    }
    else {
        classNames += " " + cm(baseClassName + "--unselected");
    }
    if (node.getClassName() !== undefined) {
        classNames += " " + node.getClassName();
    }
    var leadingContent = iconFactory ? iconFactory(node) : undefined;
    var titleContent = node.getName();
    var name = node.getName();
    function isTitleObject(obj) {
        return obj.titleContent !== undefined;
    }
    if (titleFactory !== undefined) {
        var titleObj = titleFactory(node);
        if (titleObj !== undefined) {
            if (typeof titleObj === "string") {
                titleContent = titleObj;
                name = titleObj;
            }
            else if (isTitleObject(titleObj)) {
                titleContent = titleObj.titleContent;
                name = titleObj.name;
            }
            else {
                titleContent = titleObj;
            }
        }
    }
    if (typeof leadingContent === undefined && typeof node.getIcon() !== undefined) {
        leadingContent = React.createElement("img", { src: node.getIcon(), alt: "leadingContent" });
    }
    var buttons = [];
    // allow customization of leading contents (icon) and contents
    var renderState = { leading: leadingContent, content: titleContent, name: name, buttons: buttons };
    layout.customizeTab(node, renderState);
    node._setRenderedName(renderState.name);
    var content = (React.createElement("div", { ref: contentRef, className: cm(Types_1.CLASSES.FLEXLAYOUT__TAB_BUTTON_CONTENT) }, renderState.content));
    var leading = React.createElement("div", { className: cm(Types_1.CLASSES.FLEXLAYOUT__TAB_BUTTON_LEADING) }, renderState.leading);
    if (layout.getEditingTab() === node) {
        var contentStyle = { width: contentWidth + "px" };
        content = (React.createElement("input", { style: contentStyle, ref: contentRef, className: cm(Types_1.CLASSES.FLEXLAYOUT__TAB_BUTTON_TEXTBOX), type: "text", autoFocus: true, defaultValue: node.getName(), onKeyDown: onTextBoxKeyPress, onMouseDown: onTextBoxMouseDown, onTouchStart: onTextBoxMouseDown }));
    }
    if (node.isEnableClose()) {
        var closeTitle = layout.i18nName(I18nLabel_1.I18nLabel.Close_Tab);
        buttons.push(React.createElement("div", { key: "close", title: closeTitle, className: cm(Types_1.CLASSES.FLEXLAYOUT__TAB_BUTTON_TRAILING), onMouseDown: onCloseMouseDown, onClick: onClose, onTouchStart: onCloseMouseDown }, icons === null || icons === void 0 ? void 0 : icons.close));
    }
    return (React.createElement("div", { ref: selfRef, style: {
            visibility: show ? "visible" : "hidden",
        }, className: classNames, onMouseDown: onMouseDown, onTouchStart: onMouseDown },
        leading,
        content,
        buttons));
};
exports.TabButton = TabButton;
//# sourceMappingURL=TabButton.js.map